var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabel1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.035 8.93C11.8125 8.555 11.5175 8.2475 11.1525 8.0075C10.7875 7.77 10.3875 7.58 9.95251 7.4425C9.61251 7.335 9.27501 7.2425 8.93501 7.1575V4.19C9.73501 4.3275 10.525 4.6825 11.3025 5.25L12.1125 3.47C11.815 3.215 11.4525 2.9925 11.025 2.8025C10.595 2.6125 10.1325 2.4625 9.635 2.3575C9.45 2.3175 9.265 2.2875 9.08 2.265V0.5H7.1425V2.285C6.7 2.3575 6.285 2.4775 5.9025 2.6525C5.245 2.955 4.7275 3.3675 4.345 3.8925C3.9625 4.4175 3.7725 5.0125 3.7725 5.68C3.7725 6.2725 3.88 6.76 4.0975 7.1425C4.315 7.525 4.605 7.835 4.9725 8.0725C5.3375 8.31 5.74 8.5025 6.18 8.645C6.5625 8.77 6.94 8.8775 7.315 8.975V11.85C6.875 11.8125 6.4575 11.73 6.06 11.5975C5.4975 11.4125 4.9575 11.13 4.44 10.7475L3.63 12.5275C4.16 12.93 4.795 13.2425 5.5375 13.465C6.0425 13.6175 6.5775 13.7125 7.1425 13.76V15.5H9.08V13.705C9.505 13.6325 9.9025 13.5225 10.2625 13.3625C10.925 13.07 11.44 12.6675 11.8125 12.155C12.1825 11.6425 12.3675 11.045 12.3675 10.3675C12.37 9.785 12.2575 9.305 12.035 8.93ZM6.57 6.2925C6.3475 6.1075 6.235 5.85 6.235 5.5225C6.235 5.0775 6.41001 4.7325 6.76 4.49C6.92 4.3775 7.1075 4.295 7.315 4.235V6.7025C7.015 6.59 6.7625 6.4525 6.57 6.2925ZM9.375 11.52C9.2525 11.605 9.1 11.67 8.9375 11.725V9.4325C9.185 9.5275 9.39 9.64 9.5575 9.7725C9.78 9.9475 9.8925 10.1825 9.8925 10.48C9.89 10.935 9.7175 11.28 9.375 11.52Z",
    fill: "url(#paint0_linear_13564_5767)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13564_5767",
    x1: 8.00001,
    y1: 15.5,
    x2: 8.00001,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1896,
    stopColor: "#00B970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4651,
    stopColor: "#00CD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7373,
    stopColor: "#00DA8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE8D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel1);
export default __webpack_public_path__ + "static/media/label-1.a612f1a71fc4e994fe037735c6f48bdd.svg";
export { ForwardRef as ReactComponent };